import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { useAuthStore } from '@modules/auth/store';
import { FEATURE_FLAGS_KEY } from '../constants';
import { fetchFeatureFlags } from '../services';
import FeatureFlags from '../types/feature-flags.types';

function useQueryFeatureFlags(): UseQueryResult<FeatureFlags[]> {
  const { user } = useAuthStore();
  return useQuery(
    [FEATURE_FLAGS_KEY],
    async () => {
      return await fetchFeatureFlags();
    },
    {
      enabled: user !== null,
    },
  );
}

export default useQueryFeatureFlags;
